export default "/template/resource//static/media/img_zidingyi@2x.76708e20.png";